import React, { useState } from "react";
import { Paper, MenuItem } from "@material-ui/core";
import Signbutton from "../../forms/button";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { connect } from "react-redux";
import DateFnsUtils from "@date-io/date-fns";
import CustomizedSelect from "../transactions/customizedSelect";
import { createLot, getLot } from "../../../store/actions/report";
import Transactiontable from "./Transactiontable";
import { PHYGITAL_REPORT_URL } from "../../../store/api.middleware";

const TransactionReport = (props) => {
  const [Date, setDate] = useState("");
  const [lot, setLot] = useState([]);
  const [lotValue, setlotValue] = useState("");

  const generateBatch = async () => {
    const response = await props.createLot({ AgentCode: props.token });
    const message =
      response.message === "success"
        ? response.data[0]?.level2[0]?.lotno
        : response.message;
    alert(message);
  };

  const handleDate = async (e) => {
    const date = e.toLocaleDateString("en-US");
    setDate(date);
    const response = await props.getLot({
      Date: date,
      AgentCode: props.token,
    });
    if (response.message === "success") {
      setLot(response.data);
    } else {
      alert(response.message);
      setLot([]);
    }
  };
  const handleBatch = (e) => {
    setlotValue(e.target.value);
  };
  const download = async () => {
    const RequestData = {
      Login_MailID: props.userId,
      AgentCode: props.token,
      lotno: lotValue,
    };
    try {
      const response = await fetch(`${PHYGITAL_REPORT_URL}/report`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(RequestData),
      });

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = "your-excel-file.xlsx";
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      alert(`${error}`);
    }
  };

  return (
    <div className="container-margin">
      <div className="investor-title">Report Generation</div>
      <Paper
        className="digital-form-container"
        style={{
          boxShadow: "0px 0px 2px 0px lightgray",
          width: "100%",
          padding: "50px",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "30px",
          }}
        >
          <div>
            <Signbutton
              buttontitle="Generate Batch"
              onClick={() => generateBatch()}
            />
            {lot?.length > 0 && <Transactiontable transactionData={lot} />}
          </div>
          <div>
            <div style={{ marginBottom: 20 }}>
              <div className="input-name">Date</div>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  required={true}
                  className="selects"
                  onChange={(e) => handleDate(e)}
                  format="dd/MM/yyyy"
                  helperText={""}
                  id="mui-pickers-date"
                  value={Date}
                  disableFuture
                />
              </MuiPickersUtilsProvider>
            </div>
            <CustomizedSelect
              name="Batch"
              borderColor="#a6a6a6"
              handleChange={(e) => handleBatch(e)}
              placeholder="Select Batch"
              value={lotValue}
            >
              {lot?.map((item, index) => (
                <MenuItem value={item.lotno} key={index}>
                  {item.lotno}
                </MenuItem>
              ))}
            </CustomizedSelect>
            <Signbutton
              buttontitle="Download Batch Report"
              onClick={() => download()}
            />
          </div>
        </div>
      </Paper>
    </div>
  );
};

export default connect(
  ({ authReducer }) => {
    const { token, userId } = authReducer;
    return {
      token,
      userId,
    };
  },
  {
    createLot,
    getLot,
  }
)(TransactionReport);
